import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';

import Icon from 'components/commons/icon/Icon';

const MenuItem: React.SFC<{
  path: string;
  iconName?: string;
  title: string;
  onNavLinkClick(e: React.MouseEvent, path: string): void;
  exact?: boolean;
  subActivePaths?: string[];
  isNewIcon?: boolean;
}> = props => {
  const {
    path,
    iconName,
    title,
    onNavLinkClick,
    exact = true,
    isNewIcon,
  } = props;
  const { pathname } = useLocation();
  const subActivePaths = props.subActivePaths ?? [];
  const activeClassName = 'text-red-600 font-bold';
  const isActive = subActivePaths.some(path => {
    return matchPath(pathname, { path });
  });

  return (
    <>
      {/* PC */}
      <div className="hidden md:flex flex-row text-gray-500 text-center">
        <NavLink
          to={path}
          exact={exact}
          activeClassName={activeClassName}
          className={`md:flex ${isActive ? activeClassName : ''}`}
          onClick={e => onNavLinkClick(e, path)}>
          {iconName && (
            <Icon name={iconName} className="text-xl" caption={title} />
          )}
          <p className="text-xs md:text-sm md:pl-2">{title}</p>
        </NavLink>
        {isNewIcon && (
          <div className="flex ml-1 -mt-2">
            <img src="/static/images/new.svg" alt="new" className="" />
          </div>
        )}
      </div>
      {/* SP */}
      <div className="flex md:hidden flex-row text-gray-500 text-center">
        <NavLink
          to={path}
          exact={exact}
          activeClassName={activeClassName}
          className={`md:flex ${isActive ? activeClassName : ''}`}
          onClick={e => onNavLinkClick(e, path)}>
          {iconName && (
            <Icon name={iconName} className="text-xl" caption={title} />
          )}
          <p className="text-xs md:text-sm md:pl-2">{title}</p>
        </NavLink>
        {isNewIcon && (
          <div className="flex items-start mt-0.5 -ml-2">
            <img src="/static/images/new.svg" alt="new" className="" />
          </div>
        )}
      </div>
    </>
  );
};

export default MenuItem;
